import { Compass, LayoutGrid } from "lucide-react";
import { useArchViz } from "./ArchVizContext";

// L1-only toggle between the two radial arrangements (gap #6/10).
// Sits next to ThemeToggle in the TopBar and mirrors its chrome so the
// two read as a paired control. The icon shown reflects the CURRENT
// mode; clicking switches to the other.
export function LayoutToggle() {
  const { state, dispatch } = useArchViz();
  const isCompass = state.layoutMode === "compass";
  const nextLabel = isCompass
    ? "Switch to sides layout (actors above, externals below)"
    : "Switch to compass layout (actors left, externals right)";
  return (
    <button
      type="button"
      onClick={() => dispatch({ type: "TOGGLE_LAYOUT_MODE" })}
      aria-label={nextLabel}
      title={nextLabel}
      className="relative inline-flex h-9 w-9 items-center justify-center rounded-md border border-border text-ink-muted hover:bg-surface-tint hover:text-ink-heading transition-colors duration-base ease-out-soft"
    >
      {isCompass ? <Compass className="h-5 w-5" /> : <LayoutGrid className="h-5 w-5" />}
    </button>
  );
}
